export default __webpack_public_path__ + "static/media/all-virtual-image.fa021c07.png";